<template>
  <div >
    <Vfm :show="!!item"
      @onclose="handleClose"
      style="z-index: 2200;background-color: transparent;"
      :style="{ display: item ? 'block' : 'none' }"
      class="w-full"
    >
      <div class="absolute b-0 w-full">
        <div
          class="bg-color-1 rounded-tr-15 rounded-tl-15 px-15 py-15"
          v-if="item"
        >
          <div class="flex text-12">
            <div class="rounded-10 mr-15" style="width: 40.53%">
              <GameItem :item="item" />
            </div>
            <div class="flex-1">
              <div class="flex justify-between">
                <div class="text-color-white">
                  <div class="text-15 font-700">{{ item.gameName }}</div>
                  <!-- <div class="text-color-1 mt-3">{{ item.firm_name }}</div> -->
                </div>
                <i
                  class="text-20 font-700"
                  :class="
                    item.is_collect
                      ? 'sysicon-new-love text-color-tip-3'
                      : 'sysicon-new-favorites-soild text-color-2'
                  "
                  @click="handleCollect(item)"
                ></i>
              </div>
              <!-- <div class="font-500 text-color-linear-19">
                RTP:{{ item.rtp || "88.88%" }}
              </div> -->
              <div
                class="flex justify-center items-center text-color-white h-40 rounded-5 bg-color-1 mt-10"
                v-if="item.is_hot"
              >
                <div
                  class="flex justify-center items-center w-42 bg-color-linear-07 text-color-white h-20 text-13 font-700 rounded-tl-10 rounded-br-10 mr-4"
                >
                  {{ item.is_hot == 1 ? "HOT" : "" }}
                </div>
                <span class="text-12 font-500">{{ $t("A0287") }}</span>
              </div>
              <div
                class="flex w-full text-12 flex-wrap max-h-100 overflow-y-auto" style="margin-top: 10px !important;"
              >
                <div
                  class="px-8 py-8 bg-color-2 text-color-1 rounded-5 whitespace-nowrap mr-5 shrink-0 mb-5"
                  v-for="item in tagsArr"
                  :key="item.id"
                >
                  {{ item.title }}
                </div>
              </div>
            </div>
          </div>
          <div class="info-btn flex text-15 mt-15">
            <button
              v-if="item.demo_mode"
              class="flex-1 flex justify-center items-center text-color-white h-40 rounded-5"
              @click="handlePlay(0)"
            >
              <i class="sysicon-new-play-demo text-20 mr-5"></i>
              <span class="text-15 font-700">{{ $t("A0276") }}</span>
            </button>
            <button
              class="flex-1 flex justify-center items-center text-color-white h-40 bg-color-main rounded-5"
              :class="[`btn-firm-bg-${item.mfr_id}`]"
              @click="handlePlay(1)"
            >
              <i class="sysicon-new-play-demo text-20 mr-5"></i>
              <span class="text-15 font-700">{{
                isLogin ? $t("A0275") : $t("A0003")
              }}</span>
            </button>
          </div>
        </div>
      </div>
    </Vfm>
    <!-- 进入游戏前一定要有账号 -->
    <Vfm :show="accountModal"
      style="z-index: 1000"
      :style="{ display: accountModal ? 'block' : 'none' }"
    >
      <div
        class="h-[max-content] absolute t-0 b-0 l-0 r-0 m-auto bg-color-4 rounded-10 overflow-hidden flex-col"
        style="width: 82.6%"
      >
        <!-- 头部 -->
        <div
          class="flex items-center justify-between px-14 py-14 bg-color-linear-12"
        >
          <span class="text-15 font-700 text-color-0">Tip</span
          ><i
            @click="accountModal = false"
            class="inline-block h-[max-content] w-[max-content] icon sysicon-new-clean-3 text-color-2 text-15"
          ></i>
        </div>
        <!-- 内容 -->
        <div class="px-20 pt-20">
          <span class="text-13">{{ $t("A0288") }}</span>
        </div>
        <div class="flex mt-20">
          <button
            @click="accountModal = false"
            class="flex-1 flex items-center min-h-40 justify-center w-full uppercase font-700 text-12"
          >
            {{ $t("A0221") }}
          </button>
          <button
            @click="(accountModal = false), (accountVfm = true)"
            class="flex-1 flex items-center min-h-40 justify-center w-full uppercase font-700 bg-color-main text-12"
          >
            {{ $t("A0289") }}
          </button>
        </div>
      </div>
    </Vfm>
    <Vfm :show="showPopup" class="z-1200" :class="[showPopup ? '' : 'none']">
      <div style="background: #f5f6fa; box-shadow: 0 8px 40px rgba(0,0,0,0.4);left: 50%;top:50%;width:clamp(240px,86vw,450px);transform: translate(-50%,-50%);" class=" h-[max-content] absolute m-auto rounded-10 overflow-hidden flex-col pb-20">
        <div style="display: flex;align-items: center;justify-content: center;margin: 30px 0 5px;">
          <img src="../../../assets/images/warning.png" style="width: 60px;height:60px;"/>
        </div>
        <div style="display: flex;justify-content: center;">
          <span class="text-color-0" style="font-weight: bold;font-size: 20px;text-align: center;">Saldo Elevado</span>
        </div>
        <div style="display: flex;text-align: center;margin: 16px;">
          <p style="font-size: 12px;color:#000;">O sistema detectou um lucro excessivo em sua conta, pois você é um novo usuário, por razões de segurança de seus fundos, solicite um levantamento imediatamente. Após a retirada, o sistema voltará ao normal. Para quaisquer dúvidas, entre em contato com o Serviço de Atendimento Online.</p>
        </div>
        <div v-if="showNotice" style="display: flex;text-align: center;margin: 4px 16px;">
          <p style="font-size: 12px;color:#000;">Recarregue 20 reais para se tornar membro VIP e desbloquear a função de saque.</p>
        </div>
        <div style="display: flex; gap: 10px; margin: 18px 15px 0;">
          <!-- 左侧：Sacar Agora（黄色） -->
          <div @click="goDeposit" 
              style="flex: 1; font-weight: bold; display: flex; align-items: center; justify-content: center; 
                      background: #F5A623; color: #fff; border-radius: 10px; padding: 14px 10px; 
                      font-size: 13px; cursor: pointer; transition: opacity 0.2s;"
              onmouseover="this.style.opacity='0.85'" 
              onmouseout="this.style.opacity='1'">
            Sacar Agora
          </div>
          
          <!-- 右侧：Voltar ao Inicio（灰色） -->
          <div @click="showPopup = false" 
              style="flex: 1; font-weight: bold; display: flex; align-items: center; justify-content: center; 
                      background: #9CA3AF; color: #fff; border-radius: 10px; padding: 14px 10px; 
                      font-size: 13px; cursor: pointer; transition: opacity 0.2s;"
              onmouseover="this.style.opacity='0.85'" 
              onmouseout="this.style.opacity='1'">
            Voltar ao Inicio
          </div>
        </div>
        <!-- <div @click="goDeposit" style="font-weight: bold;display: flex;align-items: center;justify-content: center;background: #32a614;color: #fff;border-radius: 10px;padding: 15px;margin:15px 15px 0;">Sacar Agora</div>
        <div @click="showPopup = false" style="font-weight: bold;display: flex;align-items: center;justify-content: center;background: #3b3d44;color: #fff;border-radius: 10px;padding: 15px;margin:10px 15px 0;">Voltar ao Inicio</div> -->
      </div>
    </Vfm>
    <AccountVfm :show="accountVfm" @onclose="accountVfm = false" />
    
  </div>
</template>
<script setup>
import { useI18n } from "vue-i18n";
const { t } = useI18n();
import Utils from "@/utils/util";
import { useNav } from "@/hooks/useNav";
import { useAppStore } from "@/stores/modules/app";
import { useUserStore } from "@/stores/modules/user";
import { computed, watch, getCurrentInstance } from "vue";
import AccountVfm from "../phone/Account.vue";
import GameItem from "@/components/phone/GameItem.vue";
const { proxy } = getCurrentInstance();
import { useGameStore } from "@/stores/modules/game";
import { apiGameCollect,apiGameDiscollect } from "@/api";
const gameStore = useGameStore();
import eventBus from "@/utils/eventBus";

const appStore = useAppStore();
const userStore = useUserStore();
const nav = useNav();
const props = defineProps({
  item: {
    type: Object,
    default: null,
  },
});
const isLogin = computed(() => {
  return userStore.isLogin;
});
const userinfo = computed(() => {
  return userStore.userinfo;
});
const itemTagsArr = computed(() => {
  if (!props.item) return [];
  const tags = props.item.tags;
  if (tags !== null && typeof tags !== "undefined") {
    return Array.isArray(tags) ? tags : String(tags).split(",");
  } else {
    return [];
  }
});
function goDeposit(){
  showPopup.value =false
  nav('/deposit')
}
const showPopup = ref(false)
const showNotice = ref(false)
const tagList = computed(() => {
  return appStore.tagList;
});
const tagsArr = computed(() => {
  return tagList.value.filter((item) =>
    itemTagsArr.value.includes(String(item["id"]))
  );
});
const emit = defineEmits(["onclose", "oncollectsuccess"]);
const accountModal = ref(false); //进入游戏前 检查是否有账号 无提示是否设置
const accountVfm = ref(false); //设置账号vfm
function handleClose() {
  console.log("gameInfo关闭？？？？")
  emit("onclose");
}
async function handlePlay(demo) {
    if (!Utils.$getLogin()) {
      return eventBus.emit("Login", 'in');
    } else if (!userinfo.value.username) {
      accountModal.value = true;
      return;
    }
  emit("onclose");
  if(userinfo.value.is_block==1){
    if(userinfo.value.is_sc == 0){
      showNotice.value = true
    }
    showPopup.value = true
    return;
  }
  
  console.log(demo);
  eventBus.emit("OnGameItem", {
    gid: props.item.id,
    mode: !demo ? props.item.demo_mode : 0,
  });
  nav("/game", {
    gid: props.item.id,
    mode: !demo ? props.item.demo_mode : 0,
  });
  gameStore.addLast7DaysGame(props.item);
}
async function handleCollect(item) {
  console.log(item)
  if (!isLogin.value) {
    handleClose();
    eventBus.emit("Login", 'in');
    return;
  }
  proxy.$Loading.show();
  let code = null;
  try {
    if(item.is_collect === 0){
      const res = await apiGameCollect({ game_id: item.id });
      code = res.code;
    }else if(item.is_collect === 1){
      const res = await apiGameDiscollect({ game_id: item.id });
      code = res.code;
    }
    if (code === 200) {
      proxy.$Toast(item.is_collect === 0 ? t("A0351") : t("A0352"));
      item.is_collect = item.is_collect === 0 ? 1 : 0;

      gameStore.updateLast7DaysGame(item);
      handleClose();
      emit("oncollectsuccess", item);
    }
  } catch (error) {
  } finally {
    proxy.$Loading.hide();
  }
}
</script>
<style lang="scss" scoped>
.btn-firm-bg-9 {
  background: var(--theme);
}
.btn-firm-bg-8 {
  background: #f90;
}
</style>
